import React, { useState, useEffect } from 'react';

// Hooks
import { useSelector, useDispatch } from 'react-redux';

// Actions
import { fetchAdminDashboardChart } from '~/redux/actions/admin-dashboard-actions';

// Utils
import { DASHBOARD_DATE_OPTIONS } from '~/utils/constants';

// Components
import StatsCard from './StatsCard';
import Chart from './Chart';
import OlcDropdownSearch from '~/components/General/OlcDropdownSearch';

// Mui components
import { Box, Container } from '@mui/material';

// Styles
import './styles.scss';

function Dashboard() {
  const [selectedDate, setSelectedDate] = useState(DASHBOARD_DATE_OPTIONS[4]);

  const dispatch = useDispatch();

  const totalOrders = useSelector((state) => state.adminDashboardReducers.numberOfOrders) || 0;

  const revenue = useSelector((state) => state.adminDashboardReducers.revenue) || 0;

  const dashboardChart = useSelector((state) => state.adminDashboardReducers.chart);

  useEffect(() => {
    dispatch(fetchAdminDashboardChart({ duration: selectedDate?.title?.toLowerCase() }));
  }, [selectedDate]);

  return (
    <Container maxWidth="xxl" className="olcAdminDashboardPage">
      <Box className="adminDashboardSummary">
        <StatsCard totalOrders={totalOrders} revenue={revenue} />
        <Box className="dateDropDown">
          <OlcDropdownSearch
            options={DASHBOARD_DATE_OPTIONS}
            selectedValue={selectedDate}
            setSelectedValue={setSelectedDate}
            searchable={false}
            placeHolderText="Select Date"
            component="overviewdateDropDown"
          />
        </Box>
      </Box>
      <Box className="graph">
        <Chart data={dashboardChart} />
      </Box>
    </Container>
  );
}

export default Dashboard;
